<template>
<div class="chapter">
<div class="inner_page">
<div class="galley">
<p>
<a id="page_normal--num_xvii--seq_17">
</a></p><a id="page_normal--num_xvii--seq_17">
<div class="block image" id="block_image--num_--seq_1">
<svg version="1.1" viewbox="0 0 400 673" width="100%" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><rect fill="#ffffff" height="673" width="400" x="0" y="0"></rect><image height="673" transform="translate(0 0)" width="400" xlink:href="a41953749_003.png"></image></svg>
</div>
</a><p><a id="page_normal--num_xvii--seq_17"></a><a id="page_normal--num_1--seq_18"></a><a id="page_normal--num_2--seq_19"> </a></p><a id="page_normal--num_2--seq_19">
</a></div><a id="page_normal--num_2--seq_19">
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// a9781847673749_part_01.vue?584a5106